var emptyConfig = {
	user: {},
	account: {},
	is_impersonate: false,
	isLoaded: null,
	rental_sources: [],
	agents: [],
	rental_statuses: [],
	bed_types: [],
	fee_types: [],
	heat_sources: [],
	building_types: [],
   parking_availabilities: [],
   parking_types: [],
	bath_types: [],
	laundry_types: [],
	landlords: [],
	counts: {sending_brokers: []},
	timestamp: 0
};

export var configReducer = (state = emptyConfig, action) => {
	var user = null;
	var newState = null;

	switch(action.type) {
		case "LOAD_ACCOUNT_CONFIG": 
			if (action.config) {
				newState = {...state, ...action.config, isLoaded: true};
				return newState;
			}
			else {
				return {...emptyConfig, isLoaded: false};
			}
		case "TURN_OFF_GETTING_STARTED" :
			if (state.isLoaded) {
				user = state.user;
				user.setting_general_tutorial = "INA";
			
				newState = {...state, user};
				return newState;
			}
			
			return state;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/configReducer.js